module.exports = __webpack_public_path__ + "static/media/amst2.e5bf3144.jpg";